export const CONTAINER_ID = 'dataviz-container';
